angular.module('webtrader').controller('LoginPage', ($scope, Account, $state, $window, $stateParams, $http) => {
  $scope.smsVerificationModalShow = false
  $scope.smsVerificationModalErrorsShow = false
  $scope.otpModalShow = false
  $scope.isTokenInvalid = false
  $scope.binaryURL = 'https://gcoption.com';

  $scope.toNewOrToClassicShow = false

  $scope.closeModalButton = function(){
    $scope.smsVerificationModalShow = false
    $scope.toNewOrToClassicShow = false
    $scope.otpModalShow = false
  }

  $scope.showToNewOrToClassicModal = () => {
    $scope.toNewOrToClassicShow = true
    $scope.goToClassic = () => {
      // link to demo options acc
      $window.location.href = "/my/webtrader_classic/options"
    }
    $scope.goToNew = () => {
      $state.go('app', {accountId: 'options'})
    }
  }

  $scope.signin = () => {
    $scope.isLoading = true
    Account.signIn($scope.login, $scope.password, $scope.fastLogin, $scope.auth_key).then((res) => {

      if (res.data.detail && typeof res != 'undefined') {
        if (res.data.detail.otp_type == 'sms'){
          $scope.smsVerificationModalShow = true
          $scope.sendToken = function(token) {
            this.isLoading = true

            $http.post('/my/webtrader/api/account/signin/', {
              login: $scope.login, password: $scope.password, fast: $scope.fastLogin,
              otp_hash: res.data.detail.otp_hash,
              otp_hashed_at: res.data.detail.otp_hashed_at,
              otp_type: res.data.detail.otp_type,
              otp_token: token
            }).then((res) => {
              $state.go('app', {accountId: $scope.login})
            }).catch((res) =>{
              $scope.smsVerificationModalErrorsShow = true
            })
          }
        } else if (res.data.detail.otp_type == 'otp') {
          $scope.otpModalShow = true
          $scope.sendToken = function(token) {
            this.isLoading = true

            $http.post('/my/webtrader/api/account/signin/', {
              login: $scope.login, password: $scope.password, fast: $scope.fastLogin,
              otp_hash: res.data.detail.otp_hash,
              otp_hashed_at: res.data.detail.otp_hashed_at,
              otp_type: res.data.detail.otp_type,
              otp_token: token
            }).then((res) => {
              $state.go('app', {accountId: $scope.login})
            }).catch((res) =>{
              $scope.isTokenInvalid = true
            })
          }
        } else {
          $scope.smsVerificationModalShow = true
          $scope.smsVerificationModalErrorsShow = true
          $scope.isTokenInvalid = true
          $scope.page = null
        }

      } else {

        if (res.data.login){
          $scope.login = res.data.login;
        }

        if (!res.data.is_options){
          $window.location.href = "/my/webtrader_classic/" + $scope.login
        } else{

          const silverDemoBinary = res.data.option_status == 'silver' && res.data.is_options && res.data.server_name == 'demo';

          if (res.data.option_status == 'gold' || res.data.option_status == 'vip' || silverDemoBinary) {

            $scope.toNewOrToClassicShow = true

            $scope.goToClassic = () => {
              // $window.location.href = "/my/webtrader_classic/" + $scope.login
              window.location.href = $scope.binaryURL  + "/my/webtrader_classic/" + $scope.login
            }

            $scope.goToNew = () => {
              window.location.href = $scope.binaryURL  + "/my/webtrader/" + $scope.login
            }
          } else {
            $state.go('app', {accountId: $scope.login})
          }
        }
      }
    }).catch((res) => {
      $scope.isLoading = false

      if (!$scope.fastLogin) {
        if (res.data.detail){
          console.log('catch red: ', res);
          alert(res.data.detail)
        } else {
          $scope.errors = res.data
        }
      }
      else{
        // show modal to enter verification code
        if(res.data.detail.otp_type == 'sms'){
          $scope.smsVerificationModalShow = true
          $scope.sendToken = function(token) {
            this.isLoading = true

            $http.post('/my/webtrader/api/account/signin/', {
              login: $scope.login, password: $scope.password, fast: $scope.fastLogin,
              otp_hash: res.data.detail.otp_hash,
              otp_hashed_at: res.data.detail.otp_hashed_at,
              otp_type: res.data.detail.otp_type,
              otp_token: token
            }).then((res) => {
              $state.go('app', {accountId: $scope.login})
            }).catch((res) =>{
              $scope.smsVerificationModalErrorsShow = true
            })
          }
        } else {
          $scope.smsVerificationModalShow = true
          $scope.smsVerificationModalErrorsShow = true
          $scope.page = null
        }
        // $scope.page = null
        // $scope.fastLogin = false
      }
    })
  }

  $scope.fastLogin = false
  if ($stateParams.account && Account.fastLoginAccounts.indexOf(parseInt($stateParams.account)) !== -1) {
    $scope.login = parseInt($stateParams.account)
    $scope.password = null
    $scope.fastLogin = true
    $scope.signin()
  }
  if ($stateParams.auth_key) {
    $scope.auth_key = $stateParams.auth_key
    $scope.signin()
  }
  if (Account.fastLoginAccounts && Account.fastLoginAccounts.length > 0) {
    $scope.fastLoginAccounts = Account.fastLoginAccounts
    $scope.page = 'fast'
  }
})
